import React, { PureComponent } from 'react';

import './styles.css';

/**
 * A case study tile.
 *
 * @typedef {Object} Props
 * @prop {String} actionLabel
 * @prop {String} brand
 * @prop {String} heading
 * @prop {String} imageName
 * @prop {string} [href]
 *
 * @augments {PureComponent<Props>}
 */
export default class CaseTile extends PureComponent {

	render () {
		const { actionLabel, brand, heading, imageName, href } = this.props;
		const imageUrl = require(`../../../assets/images/${imageName}.jpg`);
		const style = { backgroundImage: `url(${imageUrl})` };

		return (
			<a
				className='CaseTile'
				style={style}
				href={href}
				rel='noopener noreferrer'
				target='_blank'
			>
				<h2>{brand}</h2>
				<h1>{heading}</h1>
				<span>{actionLabel}</span>
			</a>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/CaseTile/CaseTile.js